import Vue from 'vue'
import Router from 'vue-router'
import { Route } from '../node_modules/vue-router/types'
import Index from './views/Index.vue'
// import Login from './views/Login.vue'
// import Teacher from './views/Teacher.vue'
// import Shansuan from './views/Shansuan.vue'
// import GuideKetang from './views/GuideKetang.vue'
// import GuideChuti from './views/GuideChuti.vue'
// import GuideSiwei from './views/GuideSiwei.vue'
// import InstallKetang from './views/InstallKetang.vue'
// import InstallChuti from './views/InstallChuti.vue'
// import InstallShansuan from './views/InstallShansuan.vue'
// import InstallTeacher from './views/InstallTeacher.vue'
// import InstallSiwei from './views/InstallSiwei.vue'
// import FeatureShansuan from './views/FeatureShansuan.vue'
import Product from './views/Product.vue'
import Download from './views/Download.vue'
import VideoIntro from './views/VideoIntro.vue'
// import Contact from './views/Contact.vue'
// import Buy from './views/Buy.vue'
import FQA from './views/FQA.vue'
// import Activity from './views/Activity.vue'
// import Voice from './views/Voice.vue'
// import Chain from './views/Chain.vue'
// import Recruited from './views/Recruited.vue'
// import Trained from './views/Trained.vue'
// import Cube from './views/Cube.vue'
// import News from './views/News/Index.vue'
// import News1 from './views/News/1.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    { path: '/', name: 'index', component: Index },
    { path: '/product/', name: 'product', component: Product },
    { path: '/download/', name: 'download', component: Download },
    { path: '/videoIntro/', name: 'videoIntro', component: VideoIntro },
    { path: '/fqa/', name: 'fqa', component: FQA },
    { path: '*', redirect: '/' } // 未知路径 重定向到主页
  ]
})
